import { DateFormatKeys, DateFormats } from "./date-formats";

export class MonthOfYearLogic {
  static isMonthValid(month: number): boolean {
    return month >= 1 && month <= 12;
  }

  static isMonthCompactlyFormatted(month: string): boolean {
    return DateFormats[DateFormatKeys.CompactMonth].test(month);
  }

  static isMonthLeadingZeroFormatted(month: string): boolean {
    return DateFormats[DateFormatKeys.TwoDigitLeadingZeroMonth].test(month);
  }
}
